<template>

  <div class="cf">
    <div class="cf-success">

      <span class="cf-success__icon">✓</span>

      <div class="cf-stack" style="gap:10px;align-items:center">
        <span class="cf-eyebrow">Wniosek przyjęty</span>
        <h1 class="cf-h1">Dziękujemy, Twój wniosek trafił do nas</h1>
        <p class="cf-lead" style="margin:0 auto">Twój wniosek oczekuje na decyzję. O jej wyniku powiadomimy Cię
          wiadomością SMS oraz e-mailem. Status wniosku możesz też sprawdzić w każdej chwili w strefie klienta.</p>
      </div>

      <ol class="cf-timeline">
        <li class="cf-timeline__item cf-timeline__item--done">
          <span class="cf-timeline__dot">✓</span>
          <span class="cf-timeline__title">Wniosek złożony</span>
          <span class="cf-timeline__desc">Otrzymaliśmy Twoje dane i wynik weryfikacji konta bankowego.</span>
        </li>
        <li class="cf-timeline__item cf-timeline__item--active">
          <span class="cf-timeline__dot">2</span>
          <span class="cf-timeline__title">Analiza i decyzja</span>
          <span class="cf-timeline__desc">Analizujemy wniosek. O decyzji poinformujemy Cię SMS-em i e-mailem.</span>
        </li>
        <li class="cf-timeline__item">
          <span class="cf-timeline__dot">3</span>
          <span class="cf-timeline__title">Umowa i wypłata</span>
          <span class="cf-timeline__desc">Po pozytywnej decyzji podpiszesz umowę, a środki trafią na wybrany rachunek.</span>
        </li>
      </ol>

      <div class="cf-row" style="justify-content:center">
        <a v-if="$root.mainpage && $root.mainpage.loggedIn" class="cf-btn cf-btn--primary" @click="$router.push({path: '/client'})">Przejdź do strefy klienta</a>
        <a v-else class="cf-btn cf-btn--ghost" @click="gotomain">Wróć na stronę główną</a>
      </div>

    </div>
  </div>

</template>

<script>

    
    
    import DynamicForm from './DynamicForm'

    export default {
     
       name: 'NauFormView',


       components: { DynamicForm },


       methods: {


        gotomain(){


            this.$router.push({path: '/'});

        }
       }



        
    }
</script>

<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-easycheck__widget {
  padding: 24px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/NauThankYouView.vue